export default __webpack_public_path__ + "static/media/info-defensa-civil.9798d487.svg";